export default __webpack_public_path__ + "static/media/new-checkbox-select.4ba1737d.svg";